import React, { Component } from 'react';
import AdminDashboardView from './AdminDashboardView';
import { url } from '../../../Server/url/GlobalUrl'


class AdminDashboardComponent extends Component {
    state={
           applicant_count : '',
           candidate_count : '',
           interview_count : '',
           private_jobs_count : '',
           council_jobs_count : '',
           active_jobs_count : '',
            }
    componentDidMount() {
        fetch((url + "/user-counts/"), {
                method: 'GET'
                })
              .then(res => res.json())
              .then(
		        (result) => {
		            console.log('result',result)
		            this.setState({'candidate_count' : result.candidate_count })
		            this.setState({'applicant_count' : result.applicant_count })
		            this.setState({'interview_count' : result.interview_count })
		            this.setState({'private_jobs_count' : result.private_jobs_count })
		            this.setState({'council_jobs_count' : result.council_jobs_count })
		            this.setState({'active_jobs_count' : result.active_jobs_count })
		            })
    }
    render() {
        return <AdminDashboardView
                candidate_count = {this.state.candidate_count}
                private_jobs_count = {this.state.private_jobs_count}
                applicant_count = {this.state.applicant_count}
                interview_count = {this.state.interview_count}
                council_jobs_count = {this.state.council_jobs_count}
                active_jobs_count = {this.state.active_jobs_count}

         />
    }
}

export default AdminDashboardComponent;